import React from "react";

interface Props {
  multiple?: boolean;
  accept?: string;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
}

const UploadButton: React.FC<Props> = ({ multiple = false, accept = "image/*", disabled = false, onChange, label = "Upload" }) => {
  return (
    <label className="inline-flex items-center space-x-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium py-2 px-4 rounded-full shadow hover:scale-[1.02] transition-transform cursor-pointer disabled:opacity-50">
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 16v-8m-4 4h8" />
      </svg>
      <span>{label}</span>
      <input type="file" accept={accept} multiple={multiple} onChange={onChange} className="hidden" disabled={disabled} />
    </label>
  );
};

export default UploadButton;
